/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/resetPassword.config.json";

export interface IResetPasswordMethods extends IPluginMethodMap {
  resetPassword(args: any, apiURL: string): Promise<any>;
}

export interface HeaderProps {
  headerName: string;
  headerValue: string;
}

export interface ResetPasswordProps {
  password: string;
  jwtToken: string;
  apiURL: string;
  headers: HeaderProps;
}

export class ResetPasswordService implements IAgentPlugin {
  readonly methods: IResetPasswordMethods;
  constructor() {
    this.methods = {
      resetPassword: this.resetPassword.bind(this),
    };
  }

  async resetPassword(args: ResetPasswordProps) {
    let headers: any = {};
    // headers[args?.headers?.headerName] = args?.headers?.headerValue;
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.resetPasswordEP}`,
        {
          jwtToken: args?.jwtToken,
          password: args?.password,
        },
        {
          headers: {
            ...headers,
          },
        }
      );
      if (res?.data) {
        console.log(`resetPassword`, res?.data);
        return {
          ...res?.data?.user,
          message: config?.resetMessage,
        };
      }
    } catch (err: any) {
      // return err?.response?.data;
      throw err;
    }
  }
}
